import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  user: any = {}
  constructor(public userService: UserService) {
    this.userService.getCurrentUser().valueChanges().subscribe((res) => {
      this.user = res;
    })
   }

  ngOnInit() {
  }

}
